import { createSharedComposable } from '@vueuse/core'
import { ref } from 'vue'

import { useConfigStore } from '@/store/config'
import { useFloorplanStore } from '@/store/floorplan'
import { useTillStore } from '@/store/till'
import { isMobile } from '@/utils/device-type'

export const useHome = createSharedComposable(() => {
  const { config } = useConfigStore()
  const { floorplanIds } = useFloorplanStore()
  const { shiftsEnabled, selectedCashTillIsStarted, shiftIsStarted } = useTillStore()

  const activeMenu = ref<string>()

  function checkRedirect() {
    if (shiftsEnabled && (!selectedCashTillIsStarted || !shiftIsStarted)) {
      return { name: 'employees' }
    } else if (activeMenu.value) {
      return { name: activeMenu.value }
    } else if (config.fastMode && config.fastModeHome && !isMobile.value) {
      activeMenu.value = 'fastMode'
      return {
        name: 'fastMode'
      }
    } else if (floorplanIds.length > 0) {
      activeMenu.value = 'floorplan'
      return { name: 'floorplan' }
    } else {
      activeMenu.value = 'delivery'
      return { name: 'delivery' }
    }
  }

  return {
    activeMenu,
    checkRedirect
  }
})
